import Vue from 'vue'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import ruLocale from '@/i18n/ru.json'
import enLocale from '@/i18n/en.json'
import kkLocale from '@/i18n/kk.json'

Vue.use(VueI18n)

const fallbackLocale = 'kk'
const userLocale = () => localStorage.getItem('user-locale') || fallbackLocale

const i18n = new VueI18n({
  locale: userLocale(),
  fallbackLocale: fallbackLocale,
  messages: { ru: ruLocale, en: enLocale, kk: kkLocale },
})

function addPrefix(prefix, locale) {
  const out = {}
  out[prefix] = locale
  return out
}

export function getLocale() {
  return i18n.locale
}

export async function fetchProcessGlobalLocale(locale) {
  locale = locale || i18n.locale
  // Prefix for Cordova
  let prefix = ''
  if (window.cordova !== undefined) {
    prefix = `${process.env.APP_BASE_URL}/`
  }
  const response = await fetch(`${prefix}/static/forms/${locale}.json`)
  const json = await response.json()
  i18n.mergeLocaleMessage(locale, json)
  return Promise.resolve()
}

export function changeLocale(locale) {
  locale = locale || userLocale()
  fetchProcessGlobalLocale(locale).then(() => {
    i18n.locale = locale
    i18n._vm.$moment.locale(locale)
    i18n._vm.$vuetify.lang.current = locale
    axios.defaults.headers.common['Accept-Language'] = locale
    document.querySelector('html').setAttribute('lang', locale)
    localStorage.setItem('user-locale', locale)
  })
}

export function mergeProcessLocale(processName, locale) {
  i18n.mergeLocaleMessage(i18n.locale, addPrefix(processName, locale))
}

export function tf(key, fallbackStr) {
  return i18n.te(key) && i18n.t(key) ? i18n.t(key) : (fallbackStr || i18n.t(key, fallbackLocale))
}

export function tpf(key, params, fallbackStr) {
  return i18n.te(key) && i18n.t(key) ? i18n.t(key, params) : (fallbackStr || i18n.t(key, params, fallbackLocale))
}

Vue.prototype.$tf = tf

Vue.prototype.$tpf = tpf

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js